import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges, OnInit,
    Output, SimpleChanges,
    ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { MessageDisplayDialogComponent } from './message-display-dialog.component';
import { Message } from './message.model';

export const iconsByTypes = {
    birthday: 'birthday.png',
    reminder: 'reminder.png',
    latepayment: 'latepayment.png',
    missed: 'missed.png',
    triggered: 'triggered.png',
    newsletter: 'newsletter.png',
    recalls: 'recalls.png',
    recall: 'recalls.png',
    sale: 'sale.png',
    seasonal: 'seasonal.png',
    shortnotice: 'shortnotice.png',
    survey: 'survey.png',
    reviews: 'reviews.png',
    twoway: 'two-way.png',

    sms: 'mobile_256x256.png',
    voice: 'phone_256x256.png',
    email: 'mail_256x256.png',
    gatewayreply: 'gatewayreply.png'
};

@Component({
    selector: 'ng-message-list',
    templateUrl: './message-list.component.html',
    styleUrls: ['./message-list.component.html'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageListComponent implements OnChanges {

    @Input() readonly messages: Array<Message>;
    @Input() readonly loading: boolean;
    @Input() readonly reportType: string;
    @Output() readonly loadDataOnScroll = new EventEmitter();

    @ViewChild('messagesScrollContainer') messagesScrollContainer: ElementRef;

    messageStateOptions: Array<SelectItem> = [
        {
            label: 'Sent',
            value: 'sent'
        },
        {
            label: 'Delivered',
            value: 'delivered'
        },
        {
            label: 'Failed',
            value: 'failed'
        }];

    selectedMessageStates: Array<string> = ['sent', 'delivered', 'failed'];

    constructor(private modalService: BsModalService,
                private router: Router) {
    }

    createDescription(message): string {
        let description = '';
        if (message.gatewayReasonDescription) {
            description += message.gatewayReasonDescription;
        }

        if (message.sendRuleIndex !== undefined) {
            description += ` Attempt #${message.sendRuleIndex}`;
        }

        return description;
    }

    iconByMessageType(type: string): string {
        if (!type) {
            return '';
        }

        const category = type
            .replace('relation:', '')
            .replace('commercial:', '')
            .replace(':', ''); // gateway:reply

        return  `/img/communications/category/${iconsByTypes[category]}`; // `/assets/img/messagetypes/${iconsByTypes[category]}`
    }

    openMessageDisplayDialog(message: Message): void {
        const initialState = {
            messageUuid: message.messageUuid,
            mediaType: message.mediaType,
            messageType: message.contentCategory === 'reminder' ? 'autoremind' : message.contentType,
            isTrackingcode: false
        };

        // Uncomment to force an SMS message
        // initialState.messageUuid = 'f373b428-d305-11ea-886c-0026b937cf5e';
        // initialState.mediaType = 'sms';

        this.modalService.show(MessageDisplayDialogComponent,
            {
                initialState,
                backdrop: 'static',
                class: 'modal-lg',
                keyboard: false // disable esc key
            });
    }

    onScrollDown(event): void {
        // console.log('scrolled DOWN!!');
        if (!this.loading) {
            // TODO: Consider setting debounce on this event?
            this.loadDataOnScroll.emit();
        }
    }

    displayDescription(message): any {
        let description = '';
        if (message.gatewayReasonDescription !== undefined) {
            description += message.gatewayReasonDescription;
        }

        if (message.sendRuleIndex !== undefined) {
            description += ` Attempt #${message.sendRuleIndex}`;
        }

        if (description !== '') {
            description += ' | ';
        }

        return description;
    }

    setRoute(route: string, param: string, paramValue: string): void {
        this.router.navigate([route], {queryParams: {[param]: paramValue}});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.messages !== undefined) {
            console.log(this.messages);
        }
    }
}
